<form>
  <div class="buttons">
    <span class="label">{{ label }}</span>
    @if (selection.length > 0) {
      <span class="button" (click)="clear()">
        Clear
      </span>
    }
  </div>
  <mat-form-field class="chip-list" appearance="fill">
    <!-- <mat-label>{{ label }}</mat-label> -->
    <input
      matInput
      type="text"
      [placeholder]="placeholder ?? ''"
      #input
      [formControl]="control"
      [matChipInputFor]="chipGrid"
      [matAutocomplete]="auto"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="selected($event)"
        >
        @for (element of filteredElements; track element) {
          <mat-option [value]="element">
            {{ element.value }}
          </mat-option>
        }
      </mat-autocomplete>
      @if (showSearchIcon) {
        <mat-icon matSuffix>search</mat-icon>
      }
    </mat-form-field>

    <mat-chip-grid #chipGrid aria-label="Fruit selection" class="chips">
      @for (selec of selection; track selec) {
        <mat-chip-row (removed)="remove(selec)">
          {{ selec.value }}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
    </mat-chip-grid>
  </form>
